const CI = {
  ibanLength: 28,
};
export { CI };
